import React from "react";
import "./header.scss";
import { useLocation, NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Nav } from "react-bootstrap";
import {  CgProfile } from "react-icons/cg";
import { RiGroupLine } from "react-icons/ri";
import { BsBriefcase, BsBell, BsGearWideConnected } from "react-icons/bs";
import storage from "utils/storage";
import { useDispatch, useSelector } from "react-redux";
import avatar from "../../../assets/images/male_avatar.png";
import { Image } from "components/shared/imagecomponent/image";

export const Header = (props) => {
  const location = useLocation();
  const history = useHistory();
  const userRole = storage.get("humlog_user_role"); // get humlog user role
  const { userDetails } = useSelector((state) => state.userReducer);

  return (
    <>
      <div className='navbar-div shadow'>
        <div className='row mx-0'>
          <div className='col-sm-3 px-0'>
            <img src='/images/common/logo.png' className='company-logo' alt='Humlog Jobs Logo' />
          </div>
          <div className='col-sm-9 text-right'>
            {location.pathname === `/user/basicdetail` ||
              location.pathname === `/companydetail` ||
              location.pathname === `/user/basicdetail/jobinterested` ? (
              <div></div>
            ) : (
              <Nav className="navbar-div">
                <NavLink
                  to={userRole === 0 ? '/jobs' : '/dashboard'}
                  activeClassName="menu_active"
                  className="nav_aa"
                >
                  <BsBriefcase className="mx-auto d-flex justify-content-center icon_uu" />{" "}
                  <p className="dashboard_menu text-center">
                    {
                      userRole === 0 ? <FormattedMessage id="jobs" defaultMessage="Jobs" /> : <FormattedMessage id="jobPosted" defaultMessage="jobPosted" />
                    }
                  </p>{" "}
                </NavLink>
                {/* <NavLink
                  to="/dashboard"
                  activeClassName="menu_active"
                  className="nav_aa"
                >
                  <CgTemplate className="icon_uu" />
                  <p
                    className={
                      location.pathname === "/dashboard"
                        ? "dashboard_menu_one text-center"
                        : "dashboard_menu text-center"
                    }
                    activeClassName="menu_active"
                  >
                    <FormattedMessage
                      id="dashboard"
                      defaultMessage="Dashboard"
                    />
                  </p>
                </NavLink> */}

                {/* <NavLink
                  to="/dashboard"
                  activeClassName="menu_active"
                  className="nav_aa"
                >
                  <CgTemplate className="icon_uu" />
                  <p
                    className={
                      location.pathname === "/dashboard"
                        ? "dashboard_menu_one text-center"
                        : "dashboard_menu text-center"
                    }
                    activeClassName="menu_active"
                  >
                    <FormattedMessage
                      id="dashboard"
                      defaultMessage="Dashboard"
                    />
                  </p>
                </NavLink> */}
                <NavLink
                  to="/community"
                  activeClassName="menu_active"
                  className="nav_aa"
                >
                  <div className="">
                    <RiGroupLine className="mx-auto d-flex justify-content-center icon_uu" />
                    <p className="dashboard_menu text-center">
                      <FormattedMessage
                        id="community"
                        defaultMessage="Community"
                      />
                    </p>
                  </div>
                </NavLink>

                <NavLink
                  to="/Notification"
                  activeClassName="menu_active"
                  className="nav_aa notification_link"
                >
                  <BsBell className="mx-auto d-flex justify-content-center icon_uu" />
                  {props.count ? <p className="notification_count">{props.count < 10 ? props.count : "9+"}</p> : ""}
                  <p className="dashboard_menu text-center">
                    {" "}
                    <FormattedMessage
                      id="notification"
                      defaultMessage="Notifications"
                    />
                  </p>
                </NavLink>

                <NavLink
                  to="/profile"
                  activeClassName="menu_active"
                  className="nav_aa"
                >
                    <div className="">
                      <CgProfile className="mx-auto d-flex justify-content-center icon_uu" />
                      <p className="dashboard_menu text-center">
                        <FormattedMessage
                          id="profile"
                          defaultMessage="Profile"
                        />
                      </p>
                    </div>
                </NavLink>

                <NavLink
                  to="/setting"
                  activeClassName="menu_active"
                  className="nav_aa"
                >
                  <div className="">
                      <BsGearWideConnected className="mx-auto d-flex justify-content-center icon_uu" />
                      <p className="dashboard_menu text-center">
                        <FormattedMessage
                          id="settings"
                          defaultMessage="Settings"
                        />
                      </p>
                    </div>
                </NavLink>
              </Nav>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
